import Model, { attr } from '@ember-data/model';

export default class V2TaskPasteModel extends Model {
  @attr('string') taskGroupId?: string; // the response will include the taskGroupId that was created
  @attr('string') copiedTaskId?: string;
  @attr('string') declare contactIds: string[];
  @attr('string') actionId?: string;
  @attr('string') resultId?: string;
  @attr('string') mediumId?: string;
  @attr('string') summary?: string;
  @attr('string') notes?: string;
  @attr('date-only') dueDate?: Date;
  @attr('date-only') completedDate?: Date;
  @attr('string') journalStageId?: string;
  @attr() assignedUserIds?: string[];
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'v2-task-paste': V2TaskPasteModel;
  }
}
